/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ groupCount: NonNullable<unknown>, memberCount: NonNullable<unknown>, groupNames: NonNullable<unknown> }} Account_Owns_Populated_GroupsInputs */

const en_us2_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You own ${i?.groupCount} group(s) with ${i?.memberCount} member(s): ${i?.groupNames}. Hand them over or remove the members first.`)
};

const pt_br2_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você é dono de ${i?.groupCount} grupo(s) com ${i?.memberCount} membro(s): ${i?.groupNames}. Transfira ou remova os membros antes.`)
};

const es_419_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eres dueño de ${i?.groupCount} grupo(s) con ${i?.memberCount} miembro(s): ${i?.groupNames}. Transfiérelos o quita a los miembros primero.`)
};

const pt_pt2_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`És dono de ${i?.groupCount} grupo(s) com ${i?.memberCount} membro(s): ${i?.groupNames}. Transfere-os ou remove os membros primeiro.`)
};

const fr_fr2_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu es propriétaire de ${i?.groupCount} groupe(s) avec ${i?.memberCount} membre(s) : ${i?.groupNames}. Transfère-les ou retire d'abord les membres.`)
};

const de_de2_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du besitzt ${i?.groupCount} Gruppe(n) mit ${i?.memberCount} Mitglied(ern): ${i?.groupNames}. Übergib sie oder entferne zuerst die Mitglieder.`)
};

const it_it2_account_owns_populated_groups = /** @type {(inputs: Account_Owns_Populated_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Possiedi ${i?.groupCount} gruppo/i con ${i?.memberCount} membro/i: ${i?.groupNames}. Trasferiscili o rimuovi prima i membri.`)
};

/**
* | output |
* | --- |
* | "You own {groupCount} group(s) with {memberCount} member(s): {groupNames}. Hand them over or remove the members first." |
*
* @param {Account_Owns_Populated_GroupsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const account_owns_populated_groups = /** @type {((inputs: Account_Owns_Populated_GroupsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Owns_Populated_GroupsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_account_owns_populated_groups(inputs)
	if (locale === "es-419") return es_419_account_owns_populated_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_account_owns_populated_groups(inputs)
	if (locale === "fr-FR") return fr_fr2_account_owns_populated_groups(inputs)
	if (locale === "de-DE") return de_de2_account_owns_populated_groups(inputs)
	if (locale === "it-IT") return it_it2_account_owns_populated_groups(inputs)
	return en_us2_account_owns_populated_groups(inputs)
});
export { account_owns_populated_groups as "account.owns_populated_groups" }